"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../../utils");
const NodeTrees_1 = require("../../utils/NodeTrees");
const findParentPathOfCurrentPath = (flowNodes, currentNode) => {
    const pathParentId = NodeTrees_1.getParentId(currentNode);
    const pathParent = pathParentId && flowNodes[pathParentId];
    if (pathParent && utils_1.isPathNode(pathParent)) {
        return pathParent;
    }
    else if (pathParent) {
        return findParentPathOfCurrentPath(flowNodes, pathParent);
    }
    return null;
};
exports.default = findParentPathOfCurrentPath;
